<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>{{text}} Category</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitCategory()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Category</label>
        <ng-select [readonly]="text === 'Update'" class="form-select" [(ngModel)]="selectedCategory.category"
          [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="0" disabled>Select Category</ng-option>
          <ng-option selected value="0" disabled *ngIf="categoryList.length<=0">No Category</ng-option>
          <ng-option *ngFor="let cat of categoryList" [value]="cat">{{cat}}</ng-option>
        </ng-select>
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Number Of Questions</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="selectedCategory.numberOfQuestions"
          [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="mb-3 mr-0 col-md-10" *ngIf="exam.examinationTypeenum==='Essay'">
        <label class="form-label">Maximum Number Of Answers</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="selectedCategory.maximumNumberOfEssayAnswers"
          [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="mb-3 mr-0 col-md-10" *ngIf="exam.examinationTypeenum==='SAQ'">
        <label class="form-label">Maximum Number Of Answers</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="selectedCategory.maximumNumberOfSAQAnswers"
          [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Instruction</label>
        <textarea type="text" class="form-control" [(ngModel)]="selectedCategory.instruction"
          [ngModelOptions]="{ standalone: true }"></textarea>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit">{{text}}</button>
    </form>
  </div>
</div>